export enum UIAudio {
  Click = 'TYCE_UI_click',
  ClickAlt = 'TYCE_UI_secondary-click',
  Hover = 'TYCE_UI_hover',
  Pop = 'TYCE_UI_pop',
  CountdownLast = 'TYCE_UI_countdown-last',
  CountdownStep = 'TYCE_UI_countdown-step',
}

export enum MusicAudio {
  Runner = 'TYCE_MUSIC_runner',
  Runner_A = 'TYCE_MUSIC_runner-layer-A',
  Runner_B = 'TYCE_MUSIC_runner-layer-B',
  Pages = 'TYCE_MUSIC_pages',
  Spiders = 'TYCE_MUSIC_spiders',
  Narnia = 'TYCE_MUSIC_narnia',
  Masks = 'TYCE_MUSIC_masks',
}

export enum SFXAudio {
  BadItem = 'TYCE_SFX_bad-item',
  GoodItem = 'TYCE_SFX_good-item',
  Dog = 'TYCE_SFX_dog',
  Milk = 'TYCE_SFX_milk',
  SpecialItem = 'TYCE_SFX_special-item',
  Spiders = 'TYCE_SFX_spiders',
  Squirrel = 'TYCE_SFX_squirrel',

  Clown = 'TYCE_SFX_clown',
  Pixels = 'TYCE_SFX_pixels',
  FunkyVeggies = 'TYCE_SFX_funky-veggies',
  Mirror = 'TYCE_SFX_mirror',
  RightLeft = 'TYCE_SFX_right-left',
  Freeze = 'TYCE_SFX_freeze',
  Heart = 'TYCE_SFX_heart',

  TV = 'TYCE_SFX_tv',
}
